function initProductGalleryNav() {
  document.querySelectorAll('media-gallery').forEach((gallery) => {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer || gallery.dataset.navReady) return;
    gallery.dataset.navReady = 'true';

    const thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!thumbnails) {
      const buttons = viewer.querySelector('.slider-buttons');
      if (buttons) buttons.style.display = 'none';
      return;
    }

    const step = (direction, event) => {
      if (event) event.preventDefault();
      const items = Array.from(thumbnails.querySelectorAll('[data-target]'));
      if (!items.length) return;
      let index = items.findIndex((item) => item.querySelector('button[aria-current]'));
      if (index < 0) index = 0;
      index = (index + direction + items.length) % items.length;
      items[index].querySelector('button').click();
    };

    // Dawn's slider-component disables these buttons because the thumbnail
    // viewer never scrolls; keep them enabled so navigation works + wraps.
    [
      [viewer.querySelector('.slider-button--prev'), -1],
      [viewer.querySelector('.slider-button--next'), 1],
    ].forEach(([button, direction]) => {
      if (!button) return;
      button.removeAttribute('disabled');
      new MutationObserver(() => {
        if (button.hasAttribute('disabled')) button.removeAttribute('disabled');
      }).observe(button, { attributes: true, attributeFilter: ['disabled'] });
      button.addEventListener('click', step.bind(null, direction));
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductGalleryNav);
} else {
  initProductGalleryNav();
}
